import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"



import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

    const Employees = () => {
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [employees, setEmployees] = useState([])
        const [categories, setCategories] = useState([])
        const [isLoading, setIsLoading] = useState(false)
        const [assigns, setAssigns] = useState([])
        const [deptList, setDeptList] = useState([])
        const [areas, setAreas] = useState([])

        const [sNo, setSNo]     = useState('')
        const [sNIN, setSNIN]   = useState('')
        const [sName, setSName] = useState('')
        const [sDept, setSDept] = useState('')
        const [sLocation, setSLocation] = useState('')
        const [sCategory, setSCategory] = useState('')
        const [sPhone, setSPhone] = useState('')
        const [sGender, setSGender] = useState('')
        const [sStatus, setSStatus] = useState('Active')
        const [sMarital, setSMarital] = useState('')
        const [sJobTitle, setSJobTitle] = useState('')

        const [staffNo, setStaffNo]     = useState('WBH-')
        const [NIN, setNIN]             = useState('')
        const [title, setTitle]         = useState('')
        const [fName, setFName]         = useState('')
        const [mName, setMName]         = useState('')
        const [lName, setLName]         = useState('')
        const [gender, setGender]       = useState('')
        const [dob, setDOB]             = useState('')
        const [pob, setPOB]             = useState('')
        const [mStatus, setMStatus]     = useState('')
        const [cellPhone, setCellPhone] = useState('')
        const [userId, setUserId]       = useState('')

        const [jobTitleOptions, setJobTitleOptions] = useState([])

        const [titleOptions, setTitleOptions]     = useState(['Mr', 'Mrs', 'Miss', 'Dr', 'Eng'])
        const [genderOptions, setGenderOptions]   = useState(['Male', 'Female'])
        const [maritalOptions, setMaritalOptions] = useState(['Single', 'Married', 'Divorced', 'Separated'])
        const [jobLocationOptions, setJobLocationOptions]     = useState([])
        const [employmentTypeOptions, setEmploymentTypeOptions] = useState(['Freelance','Full-Time Contract','Full-Time Permanent','Full-Time Probation','Part-Time Contract','Part-Time Internship'])
        const [employeeStatusOptions, setEmployeeStatusOptions]     = useState(['Active', 'Suspended', 'Retired', 'Terminated','Passed Away'])
        const [modal_employee, setmodal_employee] = useState(false);
        
        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_employee = () => {
          setmodal_employee(!modal_employee);
          removeBodyCss();
        }
        const fetchData = () => {
          axios.get(`${url.USERS}`, Config).then((r)=>{ 
            setAssigns(r.data)
          }).catch((e)=>{  
            console.log(e);
          });
          axios.get(`${url.TERRITORIES}`, Config).then((r)=>{ 
            setAreas(r.data);
          }).catch((e)=>{  
            console.log(e);
          });
          axios.get(url.DEPTS, Config).then((r)=>{ setDeptList(r.data) }).catch((e)=>console.log(e))
          axios.get(url.HRLOCATIONS, Config).then((r)=>{ setJobLocationOptions(r.data);  }).catch((e)=>{  console.log(e); });
          axios.get(url.TITLES, Config).then((r)=>{ setJobTitleOptions(r.data); }).catch((e)=>console.log(e))
        }
        
        useEffect(() => {
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
          }
          fetchData() 
        },[]);

        
        
        const handleFilterData = async () =>{
          const data = {
              id  : '',
              no  : sNo,
              nin : sNIN,
              name: sName,
              phone: sPhone,
              sex : sGender,
              status: sStatus,
              marital: sMarital,
              dept: sDept,
              jobTitle: sJobTitle,
              category: sCategory,
              location: sLocation
           }
           
          try {
            setIsLoading(true)
            const r = await axios.post(`${url.HREMPLOYEESFILTER}`, JSON.stringify(data), Config)
            setEmployees(r.data)
          } catch (e) {
            console.log(e);
          } finally {
            setIsLoading(false)
          }
        }
        const handleClearSearch = () =>{
          setSNo('')
          setSNIN('')
          setSName('')
          setSDept('')
          setSLocation('')
          setSCategory('')
          handleFilterData()
        }

        const handleClickAdd = () =>{
          tog_employee()
        }
        const handleAddEmployee = () =>{
    
          const data = {
            no        : staffNo,
            nin       : NIN,
            title     : title,
            surname   : lName,
            firstName : fName,
            middleName: mName,
            sex       : gender,
            dob       : (dob != "")?formatDate(dob):"",
            pob       : pob,
            status    : mStatus,
            userId    : userId,
            cellPhone : cellPhone,
            action    : "add"
          }
          setIsLoading(true)
          axios.post(url.HREMPLOYEES, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == "1"){
              toastr.success(r.data.message)
              tog_employee()
              history.push(`/employee-details/${be.encryptId(r.data.id)}`)
            }else{
              toastr.error(r.data.message)
            }
          }).catch((e)=>{
            console.log(e)
          }).finally(()=>{
            setIsLoading(false)
          })
        }


        const pageOptions = {
          sizePerPage: 10000,
          totalSize: employees.length, // replace later with size(orders),
          custom: true,
        }
        var node = useRef();
              
        const columns = [

        {
          dataField: 'no',
          text: 'Employee No',
          sort: true
        },
        {
          dataField: 'name',
          text: 'Name',
          sort: true
        },
        {
          dataField: 'jobTitleName',
          text: 'Title',
          sort: true
        }, 

        {
          dataField: 'deptName',
          text: 'Department',
          sort: true
        }, 
        {
          dataField: 'cellPhone',
          text: 'Phone No',
          sort: true
        }, 
        {
          dataField: "salaryScale",
          text: 'Scale',
          sort: true
        },
        {
          dataField: "grossPay",
          text: 'Gross Pay',
          sort: true,
          formatter: moneyFormatter
        },
        {
          dataField: 'employeeStatus',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'dateTime',
          order: 'desc'
        }];
        function moneyFormatter(cellContent, row){
          if (!isNaN(cellContent) && cellContent !== null && cellContent !== '') {
            return <div>{parseFloat(cellContent).toLocaleString()}</div>;
          }
          return <div>{cellContent}</div>;
        }

 
        function actionFormatter(cellContent, row){
          if (!row.id) {
              console.error('Missing row.id:', row);
              return <Button type="button" color="info" className="btn-sm btn-rounded" disabled>Details</Button>;
          }
          let encryptedId;
          try {
            encryptedId = be.encryptId(row.id);
            if (!encryptedId || typeof encryptedId !== 'string') {
              throw new Error('Invalid encrypted ID');
            }
            encryptedId = encodeURIComponent(encryptedId);
          } catch (error) {
            console.error(`Encryption failed for ID ${row.id}:`, error);
            return <Button type="button" color="info" className="btn-sm btn-rounded" disabled>Details</Button>;
          }
          const urlx = `/hwa/employee-details/${encryptedId}`; // Relative to basename
          return (
            <Button
              type="button"
              color="info"
              className="btn-sm btn-rounded"
              onClick={() => {
                window.open(urlx, '_blank');
              }}
            >
              Details
            </Button>
          );
        }
      
        function statusFormatter(cellContent, row) {
          const statusColors = {
            Active: 'success',
            Suspended: 'warning',
            Retired: 'dark',
            'Passed Away': 'secondary'
          };
          const color = statusColors[cellContent] || 'danger';
          return (
            <div>
              <Badge className={`me-2 bg-${color}`}>{cellContent}</Badge>
            </div>
          );
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Employees | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                                <Modal isOpen={modal_employee} toggle={() => { tog_employee(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Add Employee</h5>
                                    <button type="button"  onClick={() => { setmodal_employee(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Staff No</label>
                                                <input type='text' className="form-control" value={staffNo} onChange={(e)=>setStaffNo(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>National ID No</label>
                                                <input type='text' className="form-control" value={NIN} onChange={(e)=>setNIN(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Title</label>
                                                <select className="form-select" value={title} onChange={(e)=>setTitle(e.target.value)}>
                                                  <option value=''></option>
                                                  {(titleOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>First Name</label>
                                                <input type='text' className="form-control" value={fName} onChange={(e)=>setFName(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Middle Name</label>
                                                <input type='text' className="form-control" value={mName} onChange={(e)=>setMName(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Surname (Last Name)</label>
                                                <input type='text' className="form-control" value={lName} onChange={(e)=>setLName(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Gender</label>
                                                <select className="form-select" value={gender} onChange={(e)=>setGender(e.target.value)}>
                                                  <option value=''></option>
                                                  {(genderOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Date of Birth</label>
                                                <Flatpickr
                                                    className="form-control form-control"
                                                    options={{
                                                        dateFormat: "Y-m-d",
                                                        enableTime: false
                                                    }}
                                                    value={dob}
                                                    onChange={(dates)=>setDOB(dates)}
                                                    />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Place of Birth</label>
                                                <input type='text' className="form-control" value={pob} onChange={(e)=>setPOB(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Phone No</label>
                                                <input type='text' className="form-control" value={cellPhone} onChange={(e)=>setCellPhone(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Marital status</label>
                                                <select className="form-select" value={mStatus} onChange={(e)=>setMStatus(e.target.value)}>
                                                <option value=''></option>
                                                  {(maritalOptions || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                                </select>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                
                                <div className="modal-footer">
                                {isLoading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                    : ( <button type="button" className="btn btn-success" onClick={handleAddEmployee}>Save...</button> )
                                }</div>
                                </Modal> 
                     
                        <Row>
                                      
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{``}</h5>
                                        </div>
                                    </Col>

                                    
                                    </Row>
                                </div>
                                                <Row className="justify-content-center mb-1">
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Employee No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sNo} onChange={(e)=>setSNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>National ID No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sNIN} onChange={(e)=>setSNIN(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Name</label>
                                                          <input type='text' className="form-control form-control-sm" value={sName} onChange={(e)=>setSName(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Phone</label>
                                                          <input type='text' className="form-control form-control-sm" value={sPhone} onChange={(e)=>setSPhone(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Department</label>
                                                          <select className="form-select form-select-sm" value={sDept} onChange={(e)=>setSDept(e.target.value)}>
                                                          <option value="">All</option>
                                                             {(deptList || []).map((d,k)=>(
                                                              <option key={k} value={d.id}>{d.name}</option>
                                                             ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                   <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Title</label>
                                                          <select className="form-select form-select-sm" value={sJobTitle} onChange={(e)=>setSJobTitle(e.target.value)}>
                                                              <option value=''></option>
                                                                {(jobTitleOptions || []).map((t,k)=>(
                                                                  <option key={k} value={t.id}>{t.title}</option>
                                                                ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Location</label>
                                                          <select className="form-select form-select-sm" value={sLocation} onChange={(e)=>setSLocation(e.target.value)}>
                                                              <option value="">All</option>
                                                              {(jobLocationOptions || []).map((d,k)=>(
                                                                <option key={k} value={d.id}>{d.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Category</label>
                                                          <select className="form-select form-select-sm" value={sCategory} onChange={(e)=>setSCategory(e.target.value)}>
                                                              <option value="">All</option>
                                                              {employmentTypeOptions.map((c,k)=>(
                                                                  <option value={c} key={k}>{c}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Gender</label>
                                                          <select className="form-select form-select-sm" value={sGender} onChange={(e)=>setSGender(e.target.value)}>
                                                              <option value="">All</option>
                                                              <option value="Male">Male</option>
                                                              <option value="Female">Female</option>
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Status</label>
                                                          <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                              <option value="">All</option>
                                                              {(employeeStatusOptions || []).map((e,k)=>(
                                                                <option value={e} key={k}>{e}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Marital Status</label>
                                                          <select className="form-select form-select-sm" value={sMarital} onChange={(e)=>setSMarital(e.target.value)}>
                                                              <option value="">All</option>
                                                              {(maritalOptions || []).map((e,k)=>(
                                                                <option value={e} key={k}>{e}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>

                                                  
                                                </Row>
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClickAdd()}}
                                                        
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add employee data
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                                                <h5 className="card-header bg-transparent border-bottom text-uppercase">Employees ({employees.length})</h5>
                                                  <CardBody>

                                                                                             
                                {(employees.length > 0) && (
                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="id"
                                    columns={columns}
                                    data={employees}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ employees }
                                      columns={ columns }
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  
                                                  keyField='id' 
                                                  data={ employees } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                  style={{ backgroundColor: 'white' }}
                                                    {...toolkitProps.baseProps}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                                  </div>
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {((employees || []).length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No Staff data found</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      <div className="text-center mt-4">
                                        <Link
                                        to="#"
                                        onClick={()=>{handleClickAdd()}}
                                       
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Add Staff data <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default Employees;